import { useContext } from "react";
import NotificationContext from "src/context/NotificationContext";

const useNotification = () => useContext(NotificationContext);

export default useNotification;
